import * as yup from 'yup';
import { PHONE_NUMBER_DIGITS_COUNT } from '@common/const/phone';

export const createPhoneNumberValidationSchema = () => {
  return yup
    .string()
    .required('Введите номер телефона') // ToDo: replace with translated string
    .test('isPhone', 'Неправильный номер телефона', (val) => {
      // ToDo: replace with translated string
      if (!val) {
        return false;
      }

      const onlyDigits = val.replace(/\D+/g, '');

      return onlyDigits.length === PHONE_NUMBER_DIGITS_COUNT;
    });
};
